import { render, staticRenderFns } from "./directSectionFilms.vue?vue&type=template&id=498643be&scoped=true"
import script from "./directSectionFilms.vue?vue&type=script&lang=js"
export * from "./directSectionFilms.vue?vue&type=script&lang=js"
import style0 from "./directSectionFilms.vue?vue&type=style&index=0&id=498643be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498643be",
  null
  
)

export default component.exports